module.exports = __webpack_public_path__ + "img/mgh-nagoya-sp.2632e2a1.jpg";